export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-500/5 blur-3xl"></div>
        <div className="absolute -bottom-20 left-1/4 w-[400px] h-[400px] rounded-full bg-accent-500/4 blur-3xl"></div>
        <div className="absolute top-1/3 right-0 w-[300px] h-[300px] rounded-full bg-secondary-500/3 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-[1400px] px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-primary-500/15 text-primary-400 border border-primary-500/20 whitespace-nowrap">
                免费高清
              </span>
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-accent-500/15 text-accent-400 border border-accent-500/20 whitespace-nowrap">
                无广告
              </span>
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-secondary-500/15 text-secondary-400 border border-secondary-500/20 whitespace-nowrap">
                大屏TV
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-50 leading-tight tracking-wide">
              天美麻花星空影视
              <span className="block text-primary-400 text-2xl md:text-3xl lg:text-4xl mt-1 font-bold">
                超清蓝光免费在线影视平台
              </span>
            </h1>

            <p className="mt-3 text-base md:text-lg text-primary-300/80 font-medium">
              电视剧全集 · 电影大全 · 综艺动漫 · 不缓冲流畅播放
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-400 leading-relaxed max-w-xl mx-auto lg:mx-0">
              天美麻花星空影视汇集海量超清蓝光电视剧全集、热门电影大片、最新综艺动漫资源，覆盖国内外主流题材与类型。平台持续每日更新，所有内容免费在线观看，无需注册即可畅享极速不缓冲播放体验。支持手机、平板、电脑与<strong className="text-foreground-200">大屏TV版</strong>多端同步，随时随地打开即看。当前夏季剧场专题重磅上线，多部独家引进剧集和院线新片同步热映中。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-7">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-black text-primary-400">10万+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-300/40"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-black text-accent-400">4K蓝光</div>
                <div className="text-xs text-foreground-500 mt-1">超清画质</div>
              </div>
              <div className="w-px h-10 bg-background-300/40"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-black text-secondary-400">全端同步</div>
                <div className="text-xs text-foreground-500 mt-1">随时观看</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-bold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                立即观看
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto px-8 py-3 bg-background-200 hover:bg-background-300 text-foreground-200 font-medium text-sm rounded-lg border border-background-300/50 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-3xl blur-2xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-background-300/30 bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cinematic%20streaming%20platform%20visual%20with%20a%20floating%20modern%20large%20screen%20displaying%20colorful%20movie%20posters%20and%20TV%20show%20thumbnails%20arranged%20in%20an%20elegant%20grid%20layout%2C%20warm%20amber%20and%20soft%20golden%20lighting%20on%20a%20deep%20navy%20dark%20background%2C%20floating%20starry%20light%20particles%20and%20subtle%20glow%20effects%2C%20premium%20entertainment%20technology%20aesthetic%2C%20clean%20minimal%20design%2C%20soft%20cinematic%20atmosphere%20with%20rich%20contrast%20and%20depth&width=1200&height=1000&seq=hero-main-visual-2026&orientation=landscape"
                  alt="天美麻花星空影视 — 超清蓝光免费在线影视平台"
                  className="w-full aspect-[6/5] object-cover object-top"
                />
              </div>
              <div className="absolute bottom-3 right-3 flex items-center gap-2 px-3 py-1.5 rounded-lg bg-background-950/70 backdrop-blur-sm border border-background-300/20">
                <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></div>
                <span className="text-xs text-foreground-300 whitespace-nowrap">每日更新中</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}